import { getItem, STORAGE_KEYS } from '../services/storage';

const useAuth = () => {
  const getUser = () => getItem(STORAGE_KEYS.USER);
  const getStudent = () => getItem(STORAGE_KEYS.STUDENT);

  return { getUser, getStudent };
};

export default useAuth;
